import { breakPoints } from './breakPoints';

export const mediaQueries = {
  sm: `(max-width: ${breakPoints.md}rem)`,
  md: `(max-width: ${breakPoints.lg}rem)`,
  lg: `(max-width: ${breakPoints.xlg}rem)`,
  xlg: `(max-width: ${breakPoints.max}rem)`,
  max: `(min-width: ${breakPoints.max}rem)`,
};
